var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSyringe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 345.18755539924535,
    y: 345.18755539924535,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "m52.4,62.8c-1.9,0 -3.5,-1.6 -3.5,-3.5l0,-39.4c0,-0.6 -0.3,-1.1 -0.8,-1.5l-2.8,-1.9c-0.2,-0.1 -0.3,-0.4 -0.3,-0.6l0,-5.1c0,-1 -0.8,-1.8 -1.8,-1.8l-6.4,0c-1,0 -1.8,0.8 -1.8,1.8l0,5.1c0,0.3 -0.1,0.5 -0.3,0.6l-2.7,1.9c-0.5,0.3 -0.8,0.9 -0.8,1.5l0,39.5c0,1.9 -1.6,3.5 -3.5,3.5c-1,0 -1.8,0.8 -1.8,1.8s0.8,1.8 1.8,1.8l3.9,0l0,3.5l0,1.5l16.9,0l0,-1.5l0,-3.5l3.9,0c1,0 1.8,-0.8 1.8,-1.8s-0.8,-1.9 -1.8,-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    id: "svg_1",
    d: "m52.4,62.8c-1.9,0 -3.5,-1.6 -3.5,-3.5l0,-39.4c0,-0.6 -0.3,-1.1 -0.8,-1.5l-2.8,-1.9c-0.2,-0.1 -0.3,-0.4 -0.3,-0.6l0,-5.1c0,-1 -0.8,-1.8 -1.8,-1.8l-6.4,0c-1,0 -1.8,0.8 -1.8,1.8l0,5.1c0,0.3 -0.1,0.5 -0.3,0.6l-2.7,1.9c-0.5,0.3 -0.8,0.9 -0.8,1.5l0,39.5c0,1.9 -1.6,3.5 -3.5,3.5c-1,0 -1.8,0.8 -1.8,1.8s0.8,1.8 1.8,1.8l3.9,0l0,3.5l0,1.5l16.9,0l0,-1.5l0,-3.5l3.9,0c1,0 1.8,-0.8 1.8,-1.8s-0.8,-1.9 -1.8,-1.9zm0,2.5l-24.7,0c-0.4,0 -0.8,-0.3 -0.8,-0.8s0.3,-0.8 0.8,-0.8c2.5,0 4.5,-2 4.5,-4.5l0,-8.2l6.3,0l0,-1l-6.3,0l0,-11.9l6.3,0l0,-1l-6.3,0l0,-11.9l6.3,0l0,-1l-6.3,0l0,-4.4c0,-0.3 0.1,-0.5 0.3,-0.6l2.8,-1.9c0.5,-0.3 0.8,-0.9 0.8,-1.5l0,-5.1c0,-0.4 0.3,-0.8 0.8,-0.8l6.4,0c0.4,0 0.8,0.3 0.8,0.8l0,5.1c0,0.6 0.3,1.1 0.8,1.5l2.8,1.9c0.2,0.1 0.3,0.4 0.3,0.6l0,39.5c0,2.5 2,4.5 4.5,4.5c0.4,0 0.8,0.3 0.8,0.8s-0.5,0.7 -0.9,0.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyringe);
export default __webpack_public_path__ + "static/media/syringe.16a7d90a70c88bf79fcb738c9ed6198e.svg";
export { ForwardRef as ReactComponent };